var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tag',{staticClass:"oc-tag mb-2",domProps:{"innerHTML":_vm._s(_vm.wrapperKeyword(_vm.k, _vm.v))}})}
var staticRenderFns = []

export { render, staticRenderFns }